// extracted by mini-css-extract-plugin
export var inputContainer = "_sy-0";